import { Vec3 } from './vec3.js';

export class Mat3 {
  constructor(
    public values: number[],
  ) {
    if(values.length !== 9) {
      throw new Error('Invalid matrix size');
    }
  }

  static identity(): Mat3 {
    return new Mat3([
      1, 0, 0,
      0, 1, 0,
      0, 0, 1,
    ]);
  }

  static rotation2d(radians: number): Mat3 {
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);

    return new Mat3([
      cos, sin, 0,
      -sin, cos, 0,
      0, 0, 1,
    ]);
  }

  static translation2d(dx: number, dy: number): Mat3 {
    return new Mat3([
      1, 0, dx,
      0, 1, dy,
      0, 0, 1,
    ]);
  }

  vecMul(other: Vec3): Vec3 {
    return new Vec3(
        this.values[0] * other.x + this.values[1] * other.y + this.values[2] * other.w,
        this.values[3] * other.x + this.values[4] * other.y + this.values[5] * other.w,
        this.values[6] * other.x + this.values[7] * other.y + this.values[8] * other.w,
    );
  }

  matMul(other: Mat3): Mat3 {
    const result: number[] = new Array<number>(9);

    for(let i = 0; i < 3; i++) {
      for(let j = 0; j < 3; j++) {
        result[i * 3 + j] = 0;

        for(let k = 0; k < 3; k++) {
          result[i * 3 + j] += this.values[i * 3 + k] * other.values[k * 3 + j];
        }
      }
    }

    return new Mat3(result);
  }
}
